export const LOW_PRIMARY_COLOR = "#132139"; //navy
export const LOW_SECONDARY_COLOR = "#f0842a"; //orange
export const LOW_TERTIARY_COLOR = "#f29256"; //light orange
export const LOW_PULSE_COLOR = "#FFD301" //vibrant blue
export const LOW_PRIMARY_LIGHT_COLOR = "#717A88" //light navy
export const LOW_HIGHLIGHT_COLOR = "#77c970" //vibrant 




